import React from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import useAuthResetPassword from "hooks/useAuthResetPassword";
import classNames from "classnames";
import { useTurnstile } from "components/TurnstileProvider";
import validationSchema from "./validation";
import Error from "../InputGroupError";

const PasswordResetForm = () => {
  const {
    resetPassword, reset, loading, error,
  } = useAuthResetPassword();
  const { captchaToken } = useTurnstile();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  const onSubmit = (data) => {
    resetPassword(data.email, captchaToken.token);
  };

  return (
    <>
      <h3 className="login-header">Reset your password</h3>
      <p>Enter your email address and we'll email you a link to reset your password.</p>

      <form className="form" onSubmit={handleSubmit(onSubmit)}>
        <div className="form-group">
          <input
            {...register("email")}
            id="email"
            required="required"
            type="email"
            className="form-control"
            name="email"
            placeholder="Email"
          />
          <Error name="email" errors={errors} />
        </div>

        <div className="form-group">
          <button
            type="submit"
            disabled={loading || error?.message === "Captcha test failed"}
            className={classNames("link-button --bold --primary", {
              "--disabled": error?.message === "Captcha test failed",
            })}
          >
            Send Password Reset Link
          </button>
        </div>
        {reset && (
          <p
            className={classNames("text-center", {
              "login-form__error": error?.message === "Captcha test failed",
            })}
          >
            {error?.message === "Captcha test failed"
              ? "Captcha test failed. Please refresh and try again"
              : "If your account exists, an email has been sent to you to change your password. "
                + "Please allow up to 5 minutes for the email to arrive, and check your spam/junk folder."}
          </p>
        )}
      </form>
    </>
  );
};

export default PasswordResetForm;
